import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_TAXE_SCHEMA_LITERAL = {
    title: 'Schéma Taxes',
    description: 'Décrit les Taxes',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        TA_TYPE: { type: 'number' },
        TA_INTITULE: { type: ['string', 'null'] },
        TA_CODE: { type: 'string' }
    },
    required: [ 'TA_CODE' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_TAXE_SCHEMA_LITERAL);
export type RxFTaxeDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_TAXE_SCHEMA: RxJsonSchema<RxFTaxeDocumentType> = F_TAXE_SCHEMA_LITERAL;
